import { msg } from "@lingui/core/macro";
import { getI18n } from "~/lib/i18n/i18n";

type AuthErrorContext = "login" | "signup";

export const getFriendlyAuthErrorMessage = (
  message: string | undefined,
  fallback: string,
  context: AuthErrorContext,
) => {
  const normalized = message?.trim().toLowerCase() ?? "";

  if (normalized.includes("credential account not found")) {
    return getI18n()._(
      msg`No password is set for this account yet. Continue with Google or use Forgot password to create one.`,
    );
  }

  if (
    context === "signup" &&
    (normalized.includes("user already exists") ||
      normalized.includes("account already exists") ||
      normalized.includes("failed to create user"))
  ) {
    return getI18n()._(
      msg`An account already exists for this email. Continue with your existing sign-in method or use Forgot password to add email sign-in.`,
    );
  }

  return message && message.length > 0 ? message : fallback;
};
